document.addEventListener("DOMContentLoaded", function() {
  const cards = Array.from(document.querySelectorAll('.art-card'));

  if (!cards.length) return;

  // --- Desktop containers ---
  const nameSelect = document.getElementById('filter-name-select');
  const gradeContainer = document.getElementById('filter-grades-options');
  const locationContainer = document.getElementById('filter-location-options');

  // --- Mobile drawer elements ---
  const filterDrawerBtn = document.querySelector(".js-drawer-open-collection-filters");
  const filterDrawer = document.getElementById("FilterDrawer");
  const filterDrawerClose = filterDrawer.querySelector(".js-drawer-close");
  const filterForm = filterDrawer.querySelector(".drawer__scrollable.filter-form");

  const nameSelectMobile = document.getElementById('filter-name-mobile');
  const gradeContainerMobile = document.getElementById('filter-grades-options-mobile');
  const locationContainerMobile = document.getElementById('filter-location-options-mobile');

  // --- Utility: populate filters ---
  function populateFilters() {
    const names = [...new Set(cards.map(c => c.dataset.name).filter(Boolean))].sort();
    const grades = [...new Set(cards.map(c => c.dataset.grade).filter(Boolean))].sort();
    const locations = [...new Set(cards.map(c => c.dataset.location).filter(Boolean))].sort();

    // Names
    if(nameSelect) {
      nameSelect.innerHTML = '<option value="">All Artists</option>';
      names.forEach(name => {
        const opt = document.createElement('option');
        opt.value = name;
        opt.textContent = name;
        nameSelect.appendChild(opt);
      });
    }
    if(nameSelectMobile) {
      nameSelectMobile.innerHTML = '<option value="">All Artists</option>';
      names.forEach(name => {
        const opt = document.createElement('option');
        opt.value = name;
        opt.textContent = name;
        nameSelectMobile.appendChild(opt);
      });
    }

    // Grades
    function populateCheckboxes(container, items) {
      if(!container) return;
      container.innerHTML = '';
      items.forEach(item => {
        const label = document.createElement('label');
        label.innerHTML = `<input type="checkbox" name="${container.id.includes('grades') ? 'grade' : 'location'}" value="${item}"> <span>${item}</span>`;
        container.appendChild(label);
      });
    }

    populateCheckboxes(gradeContainer, grades);
    populateCheckboxes(gradeContainerMobile, grades);
    populateCheckboxes(locationContainer, locations);
    populateCheckboxes(locationContainerMobile, locations);
  }

  // --- Drawer functionality (mobile) ---
  let isOpen = false;
  let lastFocusedElement = null;

  function trapFocus(container) {
    const focusableElements = container.querySelectorAll(
      'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])'
    );
    const firstEl = focusableElements[0];
    const lastEl = focusableElements[focusableElements.length - 1];
    function handleTab(e) {
      if(e.key === "Tab") {
        if(e.shiftKey && document.activeElement === firstEl) { e.preventDefault(); lastEl.focus(); }
        else if(!e.shiftKey && document.activeElement === lastEl) { e.preventDefault(); firstEl.focus(); }
      }
      if(e.key === "Escape") closeDrawer();
    }
    container.addEventListener("keydown", handleTab);
    return () => container.removeEventListener("keydown", handleTab);
  }

  function openDrawer() {
    if(isOpen) return;
    lastFocusedElement = document.activeElement;
    filterDrawer.classList.add("drawer--is-open");
    document.documentElement.classList.add("js-drawer-open");
    filterDrawerBtn.setAttribute("aria-expanded", "true");
    filterDrawer._removeTrap = trapFocus(filterDrawer);
    isOpen = true;
  }

  function closeDrawer() {
    if(!isOpen) return;
    filterDrawer.classList.remove("drawer--is-open");
    document.documentElement.classList.remove("js-drawer-open");
    filterDrawerBtn.setAttribute("aria-expanded", "false");
    isOpen = false;
    if(lastFocusedElement) lastFocusedElement.focus();
    if(filterDrawer._removeTrap) filterDrawer._removeTrap();
  }

  filterDrawerBtn.addEventListener("click", e => { e.preventDefault(); openDrawer(); });
  filterDrawerClose.addEventListener("click", e => { e.preventDefault(); closeDrawer(); });
  document.addEventListener("click", e => {
    if(!isOpen) return;
    if(!filterDrawer.contains(e.target) && !filterDrawerBtn.contains(e.target)) closeDrawer();
  });
  document.addEventListener("keyup", e => { if(e.key === "Escape" && isOpen) closeDrawer(); });

  // --- Collapsible open by default ---
  function openCollapsibles() {
    if(!filterForm) return;
    const groups = filterForm.querySelectorAll(".collection-sidebar__group");
    groups.forEach(group => {
      const btn = group.querySelector(".collapsible-trigger");
      const content = group.querySelector(".collapsible-content");
      if(btn && content) {
        btn.classList.add("is-open");
        btn.setAttribute("aria-expanded", "true");
        content.classList.add("is-open");
        content.style.height = content.scrollHeight + "px";
      }
    });
  }

  // --- Sync & Apply Filters ---
  function applyFilters() {
    const selectedName = nameSelect?.value || nameSelectMobile?.value;
    const selectedGrades = Array.from(document.querySelectorAll('#filter-grades-options input:checked, #filter-grades-options-mobile input:checked')).map(cb => cb.value);
    const selectedLocations = Array.from(document.querySelectorAll('#filter-location-options input:checked, #filter-location-options-mobile input:checked')).map(cb => cb.value);

    cards.forEach(card => {
      const matchName = !selectedName || card.dataset.name === selectedName;
      const matchGrade = selectedGrades.length === 0 || selectedGrades.includes(card.dataset.grade);
      const matchLocation = selectedLocations.length === 0 || selectedLocations.includes(card.dataset.location);
      card.style.display = matchName && matchGrade && matchLocation ? '' : 'none';
    });
  }

  // --- Event listeners ---
  if(nameSelect) nameSelect.addEventListener('change', () => { nameSelectMobile.value = nameSelect.value; applyFilters(); });
  if(nameSelectMobile) nameSelectMobile.addEventListener('change', () => { nameSelect.value = nameSelectMobile.value; applyFilters(); });

  // Desktop & Mobile checkboxes (delegated)
  document.addEventListener('change', e => {
    if(e.target.name === 'grade' || e.target.name === 'location') applyFilters();
  });

  // --- Initialize ---
  populateFilters();
  openCollapsibles();
});